export const DISPATCH_OWNED_RUNTIME_MODE = "dispatch-owned-runtime" as const;
export const WAKELOOP_DISPATCH_RUNTIME_MODE_ENV =
  "WAKELOOP_DISPATCH_RUNTIME_MODE";
export const WAKELOOP_DISPATCH_RUNTIME_DISPATCH_ID_ENV =
  "WAKELOOP_DISPATCH_RUNTIME_DISPATCH_ID";
export const WAKELOOP_DISPATCH_RUNTIME_TARGET_PROFILE_ID_ENV =
  "WAKELOOP_DISPATCH_RUNTIME_TARGET_PROFILE_ID";
export const WAKELOOP_USER_FACING_CLI_COMMAND_ENV =
  "WAKELOOP_USER_FACING_CLI_COMMAND";
